import React from 'react';
import {classes} from './PaymentAndPlaceOrderSkeleton.st.css';
import {SkeletonSection} from '../../../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../../../../common/components/Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../../../../common/components/Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export const PaymentAndPlaceOrderSkeleton = ({dataHook}: {dataHook?: string}) => (
  <div className={classes.root} data-hook={dataHook}>
    <SkeletonSection>
      <SkeletonRow>
        <SkeletonLineWrapper className={classes.xl} />
      </SkeletonRow>
      <SkeletonRow>
        <SkeletonLineWrapper className={classes.medium} />
      </SkeletonRow>
      <SkeletonRow>
        <SkeletonLineWrapper className={classes.small} />
      </SkeletonRow>
      <SkeletonRow>
        <SkeletonLineWrapper className={classes.large} />
      </SkeletonRow>
    </SkeletonSection>
  </div>
);
